import RouteScroller from './RouteScroller';

export default RouteScroller;
